__turbopack_context__.v({
  "resultsMessageQuery": "QmdhVa_resultsMessageQuery",
  "totalResults": "QmdhVa_totalResults",
});
